import { Scribbles } from "@somethings-ui/core/assets";

export function WallEmptyState() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6">
      <img
        src={Scribbles.orangeLoops}
        alt=""
        aria-hidden
        className="size-24 object-contain"
      />
      <h2 className="font-heading text-header-3 text-text-primary">
        No profile yet
      </h2>
    </div>
  );
}
